import { defineMessages } from 'react-intl';

export const EXPIRES_BEFORE = 'expires_before';
export const AFTER_CLOSING_WINDOW = 'after_closing_window';
export const BEFORE_OPENING_WINDOW = 'before_opening_window';
export const OVERLAPS = 'overlaps';
export const USER_MAX_PER_CYCLE_REACHED = 'user_max_per_cycle_reached';
export const VENUE_MAX_PER_CYCLE_REACHED = 'venue_max_per_cycle_reached';
export const OUT_OF_SPOTS = 'out_of_spots';
export const CLASS_PREREQUISITES_NOT_MET = 'class_prerequisites_not_met';
export const OUTSIDE_OF_AVAILABLE_MSA = 'outside_of_available_msa';
export const FAILED_PAYMENT = 'failed_payment';
export const PLAN_DOES_NOT_ALLOW_RESERVATIONS = 'plan_does_not_allow_reservations';
export const RESERVED = 'reserved';

export default defineMessages({
  [EXPIRES_BEFORE]: {
    id: 'availability-reasons.expiresBefore',
    defaultMessage: 'This class time has passed.',
  },
  [AFTER_CLOSING_WINDOW]: {
    id: 'availability-reasons.afterClosingWindow',
    defaultMessage: 'The booking window is now closed.',
  },
  [BEFORE_OPENING_WINDOW]: {
    id: 'availability-reasons.beforeOpeningWindow',
    defaultMessage: 'The booking window is not open yet.',
  },
  [OVERLAPS]: {
    id: 'availability-reasons.overlaps',
    defaultMessage: 'You have another reservation at this time.',
  },
  [USER_MAX_PER_CYCLE_REACHED]: {
    id: 'availability-reasons.userMaxPerCycleReached',
    defaultMessage: 'You have used all of the classes in your plan this cycle.',
  },
  [VENUE_MAX_PER_CYCLE_REACHED]: {
    id: 'availability-reason.venueMaxPerCycleReached',
    defaultMessage: 'You have used all of your visits to this studio this cycle.',
  },
  [OUT_OF_SPOTS]: {
    id: 'availability-reason.outOfSpots',
    defaultMessage: 'There are no spots left for this class.',
  },
  [CLASS_PREREQUISITES_NOT_MET]: {
    id: 'availability-reason.classPrerequisitesNotMet',
    defaultMessage: 'Pre-requisites are required to book this class.',
  },
  [OUTSIDE_OF_AVAILABLE_MSA]: {
    id: 'availability-reason.outsideOfAvailableMsa',
    defaultMessage: 'This class is not available in your home city.',
  },
  [FAILED_PAYMENT]: {
    id: 'availability-reason.failedPayment',
    defaultMessage: 'Please update your billing information.',
  },
  [PLAN_DOES_NOT_ALLOW_RESERVATIONS]: {
    id: 'availability-reason.planDoesNotAllowReservations',
    defaultMessage: 'This class is only available for members on a ClassPass subscription.',
  },
});
